import { useFetch } from 'utils/sdk';

export interface OverallResponseChartDataResponse {
  group_field_type: string;
  group_field_value: string;
  group_results: {
    x: string | number | Date | null | undefined;
    y: number;
  };
}

export interface ChartFilterProps {
  gender: string;
  ethnicity: string;
  grade: string;
  unit: string;
  state: string;
  is_low_income: string;
  is_on_individualized_education_plan: string;
  english_learner_status: string;
  standard_code: string;
}

export const useOverallResponseChartData = ({
  option,
  filters
}: {
  option: string;
  filters: ChartFilterProps;
}) =>
  useFetch<Array<OverallResponseChartDataResponse>>(
    `/api/v1/tags/research-portal/overall-response-chart/`,
    { option: option, ...filters }
  );

export interface SubmissionsVolumeChartDataResponse {
  group_field_type: string;
  group_field_value: string;
  submission_volume: number;
}

export const useSubmissionsVolumeChartData = ({
  option,
  filters
}: {
  option: string;
  filters: ChartFilterProps;
}) =>
  useFetch<Array<SubmissionsVolumeChartDataResponse>>(
    `/api/v1/tags/research-portal/submission-volume-chart/`,
    { option: option, ...filters }
  );

export interface MisconceptionsChartDataResponse {
  misconception_name: string;
  occurence_count: number;
}

export const useMisconceptionsChartData = ({
  filters
}: {
  filters: ChartFilterProps;
}) =>
  useFetch<Array<MisconceptionsChartDataResponse>>(
    `/api/v1/tags/research-portal/misconceptions-chart/`,
    {
      ...filters
    }
  );

export const useMisconceptionsCoOccurrenceChartData = ({
  filters
}: {
  filters: ChartFilterProps;
}) =>
  useFetch<Array<Array<number>>>(
    `/api/v1/tags/research-portal/misconceptions-co-occurrence-chart/`,
    {
      ...filters
    }
  );
